<template>
  <div class="code-input-component">
    <div style="left: calc(43vw - 107px); position: relative">
      <div class="input-container">
        <div
          v-for="i in 6"
          :key="i"
          class="line"
          :class="{ hide: inputLength >= i }"
        ></div>
      </div>
      <input ref="input" v-model="input" class="code-input" maxlength="6" />
    </div>
  </div>
</template>

<script>
export default {
  name: "CodeInputComponent",
  model: {
    prop: "onChange",
    event: "updateVal",
  },
  props: {
    // input输入文字
    onChange: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      input: "", // 文本输入框绑定文字
    };
  },
  computed: {
    /**
     * 计算输入长度
     */
    inputLength() {
      return this.input.length;
    },
  },
  watch: {
    input(val) {
      this.$emit("updateVal", val);
    },
    onChange(val) {
      this.input = val;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.code-input-component {
  font-family: AppleSystemUIFont, -apple-system, BlinkMacSystemFont, sans-serif !important;
  position: relative;
  width: 85vw;
  .input-container {
    display: flex;
    width: 210px;
    align-items: center;
    justify-content: space-between;
    height: 34px;
    .line {
      width: 20px;
      height: 2px;
      background: black;
      &.hide {
        background: transparent;
      }
    }
  }
  .code-input {
    height: 34px;
    width: 250px;
    position: absolute;
    top: 0;
    letter-spacing: 23px;
    left: 0;
    background: transparent;
    border: 0;
    font-size: 28px;
  }
}
</style>
